
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class PageHeader extends Vue {
  @Prop({ default: false })
  public noContainer!: boolean

  @Prop({ default: '' })
  public customClass!: string
}
